export default "__VITE_ASSET__o$BxzJXL__"